// ─── Warranties (static) ────────────────────────────────────────────────────

export function WarrantiesSection() {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <h3 className="text-sm font-semibold text-gray-900 mb-3">Garantie-Formeln</h3>
      <p className="text-sm text-gray-500 mb-4">Automatische Garantie-Berechnung basierend auf Hersteller-Regeln.</p>
      <div className="space-y-3">
        {[
          { manufacturer: 'HP / HPE', warranty: '36 Monate', rule: 'Ab Kaufdatum, CarePack erweiterbar' },
          { manufacturer: 'Dell', warranty: '36 Monate', rule: 'Ab Versanddatum, ProSupport optional' },
          { manufacturer: 'Lenovo', warranty: '12-36 Monate', rule: 'Produktabhängig, Premier Support' },
          { manufacturer: 'Ubiquiti', warranty: '24 Monate', rule: 'Ab Kaufdatum' },
          { manufacturer: 'APC / Schneider', warranty: '24 Monate', rule: 'Batterie: 12 Monate' },
        ].map((w) => (
          <div key={w.manufacturer} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0">
            <div>
              <p className="text-sm font-medium text-gray-900">{w.manufacturer}</p>
              <p className="text-xs text-gray-500">{w.rule}</p>
            </div>
            <span className="text-sm font-semibold text-brand-600">{w.warranty}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
